import { createContext, type FC, type ReactNode, useCallback, useContext, useMemo, useState } from 'react';

interface AnimeModeContextType {
	isAnimeMode: boolean;
	toggleAnimeMode: () => void;
}

const AnimeModeContext = createContext<AnimeModeContextType>({
	isAnimeMode: false,
	toggleAnimeMode: () => {},
});

const STORAGE_KEY = 'animeMode';

interface AnimeModeProviderProps {
	children: ReactNode;
}

export const AnimeModeProvider: FC<AnimeModeProviderProps> = ({ children }) => {
	const [isAnimeMode, setIsAnimeMode] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true');

	const toggleAnimeMode = useCallback(() => {
		setIsAnimeMode(prev => {
			const next = !prev;
			localStorage.setItem(STORAGE_KEY, String(next));

			return next;
		});
	}, []);

	const value = useMemo(() => ({ isAnimeMode, toggleAnimeMode }), [isAnimeMode, toggleAnimeMode]);

	return <AnimeModeContext.Provider value={value}>{children}</AnimeModeContext.Provider>;
};

export const useAnimeMode = (): AnimeModeContextType => useContext(AnimeModeContext);
